import {LOCATE_HIDE_HEADER} from "../types";

const hideHeader = (visible) => {
  return ({type: LOCATE_HIDE_HEADER, payload: {hideHeader: visible}});
};

export default hideHeader;